import _t from 'i18n!nls/xdp';

export const getZeroStateWelcomeOptions = (): string[] => [
  _t(
    "Whether this program is right for you depends on what you're working toward. Tell me a bit about your goals and I'll give you a straight answer."
  ),
  _t(
    "Whether this is worth your time depends on your background and what you're trying to accomplish. Share a little and I'll give you an honest take, including whether something else might fit better."
  ),
  _t(
    'Whether this program is a good fit really depends on you. Ask me anything, or try one of the prompts below to get started.'
  ),
  _t(
    "Whether this is right for you is a good question to work through together. Tell me about your goals and I'll help you figure it out."
  ),
  _t(
    "Whether this program fits you depends on your background, your goals, and what you want to be able to do when you're done. Let's figure it out."
  ),
];

export const getZeroStatePromptPills = (): string[] => [
  _t('I have no experience. Can I keep up?'),
  _t('I already know some of this. Will I be bored?'),
  _t("How do I know if I'm ready?"),
  _t('What kind of person does well in this?'),
  _t("I'm switching careers. Is this a good start?"),
  _t('What background do most learners have?'),
  _t('How does this compare to individual courses?'),
  _t('Specialization or Professional Certificate?'),
  _t('Is there a better option for a beginner?'),
  _t('What am I missing if I skip this?'),
  _t('What jobs does this actually help me get?'),
  _t('Will employers take this certificate seriously?'),
  _t('What do people do right after completing this?'),
  _t('Does this credential carry weight outside the U.S.?'),
  _t('I want a promotion, not a career change. Is this still worth it?'),
  _t("I'm not sure what I want yet. Can you help?"),
  _t('What does this do better than the alternatives?'),
  _t('How long does this take if I work full-time?'),
  _t("If I start and don't love it, what are my options?"),
  _t("What's the very first thing I'd learn?"),
];

export const pickRandom = <T>(items: readonly T[], count: number): T[] => {
  const pool = [...items];
  const result: T[] = [];
  while (result.length < count && pool.length > 0) {
    const index = Math.floor(Math.random() * pool.length);
    const [picked] = pool.splice(index, 1);
    if (picked !== undefined) {
      result.push(picked);
    }
  }
  return result;
};
